import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var PageFilledIcon = createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M18.71,8.68,13.29,3.26a1,1,0,0,0-.7-.29H7A2,2,0,0,0,5,5V19a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2V9.38A1,1,0,0,0,18.71,8.68ZM13,9V5l4,4Z"
}), 'PageFilledIcon');